import { useQuery } from '@tanstack/react-query';
import { IGetMedicationsParams } from './types';
import { fetchMedications } from '../../apis/medication';

export function useMedications(params: IGetMedicationsParams) {
  const { patient_id } = params;

  const { data, isError, isLoading } = useQuery({
    queryKey: ['medication-list'],
    queryFn: () => fetchMedications(patient_id),
  });

  return {
    isLoading: isLoading,
    isError: isError,
    medications: data,
  };
}
